import React, { useEffect, useState } from 'react';
import { USAGE_INFO_API_URL } from '../../config';
import './Analytics.css';
import { withAuth, AuthContextProps } from '../../LocalAuthWrapper';
import useFetchGet from '../../hooks/useFetch';
import UsageEvent, { IUsageEvent, UsageEventProps } from '../UsageEvent';
import UsageEventDetails from '../UsageEventDetails';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';

const Analytics: React.FC<AuthContextProps> = (props) => {
  const [state, setState] = useState({
    showList: true,
    sortBy: 'created_at' as UsageEventProps['sortBy'],
    sortDirection: 'descend' as UsageEventProps['sortDirection'],
    details: {
      event_type: '',
      id: 0,
      plan: '',
      job_id: '',
      title: '',
      status: '',
      metadata: { data_source: '', description: '', file_type: '', title: '' },
      created_at: '',
      usage_time: 0,
      usage: { bytes: 0, chars: 0, secs: 0 },
      logged_at: '',
      user_id: '',
    },
  });

  const [page, setPage] = useState({
    current: 1,
    perPage: 10,
  });

  const events = useFetchGet<IUsageEvent[]>(`${USAGE_INFO_API_URL}/events`, props.authCtx.accessToken) || [];
  const history = useHistory();
  const match = useRouteMatch<{ eventType: string; uniqueId: string }>('/admin/analytics/:eventType/:uniqueId');

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const run = async () => {
      if (match) {
        try {
          const jobId = `${match?.params.eventType}/${match?.params.uniqueId}`;
          const response = await fetch(`${USAGE_INFO_API_URL}/events/${jobId}`, {
            headers: { authorization: `Bearer ${props.authCtx.accessToken}` },
            signal,
          });
          const json = await response.json();
          setState({ ...state, showList: false, details: json });
        } catch (e) {
          if (signal.aborted) return;
          throw e;
        }
      }
    };
    run();

    return () => {
      controller.abort('cancelled');
    };
  }, [match?.params.eventType, match?.params.uniqueId, props.authCtx.accessToken]);

  const handleClick = (jobId: string) => {
    history.push(`/admin/analytics/${jobId}`);
  };

  const handleOnClickBack = () => {
    history.goBack();
  };

  const details = state.details;
  const sortBy = state.sortBy;
  const sortDirection = state.sortDirection;
  return (
    <div className='container-wrapper'>
      <Route path='/admin/analytics' exact>
        <UsageEvent
          events={events}
          sortBy={sortBy}
          sortDirection={state.sortDirection}
          handleSort={(newSortBy) =>
            setState({
              ...state,
              sortDirection: newSortBy === sortBy ? (sortDirection === 'ascend' ? 'descend' : 'ascend') : 'descend',
              sortBy: newSortBy,
            })
          }
          page={page}
          handlePage={(page) => setPage(page)}
          onClickDetails={handleClick}
        />
      </Route>
      <Route path='/admin/analytics/*'>
        <UsageEventDetails event={details} onClickBack={handleOnClickBack} />
      </Route>
    </div>
  );
};

export default withAuth(Analytics);
